export default __webpack_public_path__ + "static/media/Strom's Sabre.2d5ae2af.jpg";